import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TriangleAlert } from "lucide-react";

// Custom Icon component with circular SVG progress animation
const CircularProgressErrorIcon = ({ autoClose = 4000 }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, 100 - (elapsed / autoClose) * 100);
      setProgress(remaining);
      if (remaining <= 0) clearInterval(interval);
    }, 30);

    return () => clearInterval(interval);
  }, [autoClose]);

  const size = 32;
  const strokeWidth = 2.5;
  const center = size / 2;
  const radius = center - strokeWidth;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className="relative flex items-center justify-center shrink-0 w-8 h-8">
      {/* Animated Circular Progress Ring */}
      <svg
        viewBox={`0 0 ${size} ${size}`}
        className="absolute top-0 left-0 w-full h-full -rotate-90"
      >
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke="rgba(255, 255, 255, 0.25)"
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke="#FFFFFF"
          strokeWidth={strokeWidth}
          fill="transparent"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          strokeLinecap="round"
          className="transition-all ease-linear"
        />
      </svg>

      {/* Lucide Danger Icon */}
      <span className="relative z-10 flex items-center justify-center w-5 h-5 rounded-full bg-white/20 text-white">
        <TriangleAlert size={12} strokeWidth={2.5} />
      </span>
    </div>
  );
};

const errorToast = (message) => {
  const autoCloseDuration = 4000;

  // Passing a custom render function with gap-3 guarantees the spacing works in Tailwind
  toast.error(
    <div className="flex items-center gap-3">
      <CircularProgressErrorIcon autoClose={autoCloseDuration} />
      <span>{message || "An unexpected error occurred"}</span>
    </div>,
    {
      position: "bottom-right",
      autoClose: autoCloseDuration,
      hideProgressBar: true,
      icon: false, // Turn off library icon
      closeButton: false, // Turn off library close button
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      style: {
        backgroundColor: "#EA4335",
        color: "#FFFFFF",
        borderRadius: "16px",
        boxShadow: "0 10px 30px -5px rgba(234, 67, 53, 0.35)",
        fontFamily: "inherit",
        fontSize: "14px",
        fontWeight: "500",
        padding: "12px 18px",
        border: "1px solid rgba(255, 255, 255, 0.2)",
      },
    },
  );
};

export default errorToast;
